<template>
  <div>
    <div class="svip">
      <div class="svip-title">{{svipData.title}}</div>
      <div class="svip-title fz48">{{svipData.titleChild}}</div>
      <img :src="svipData.imageUrl" class="svip-img"/>
      <div class="one">
        <table width="100%">
          <tr v-for="(item,index) in repayLoanList" :key="index" :class="['one-item',{'mt10':svipData.breakBlock+1===index}]">
            <td width="50%">{{item[0]}}</td>
            <td width="50%">{{item[1]}}</td>
          </tr>
        </table>
      </div>
      <nd-button class="btn" @click="judgeOrder">{{svipData.buyButtonText}}</nd-button>
      <p @click="next" class="next">继续还款</p>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  props: {
    svipData: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    bannerList () {
      return this.svipData.bannerList || []
    },
    repayLoanList () {
      return this.svipData.repayLoanList || []
    }
  },
  data () {
    return {
    }
  },
  methods: {
    ...mapActions('vip', [
      'memberInfo'
    ]),
    next () {
      this.$emit('next')
    },
    judgeOrder () {
      this.$report({
        id: 10407
      })
      this.$emit('judgeOrder')
    }
  }
}
</script>
<style scoped lang="less">
@import "../../../assets/less/mixin.less";

.fz48{
  font-size:44px !important;
}
.svip{
  width: 620px;
  background: linear-gradient(180deg, #FF4633 0%, #FFFFFF 100%);
  border-radius: 30px;
  padding:46px 30px 29px;
  &-title{
    // height: 67px;
    font-size: 54px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 67px;
    text-align: center;
  }
  &-img{
    width:560px;
    height:70px;
    margin:15px auto 0;
  }
  &-more{
    margin-top:40px;
    text-align: center;
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 37px;
    position: relative;
  }
  &-more::before{
    position: absolute;
    content:'';
    display: block;
    width: 120px;
    height: 1px;
    background: #FF4633;
    top:20px;
  }
  &-more::after{
    position: absolute;
    content:'';
    display: block;
    width: 120px;
    height: 1px;
    background: #FF4633;
    top:20px;
    left:440px;
  }
  &-img{
    // margin:12px;
    display: flex;
    justify-content: space-between;
    &-item{
      width: 265px;
      height: 100px;
      background: #FFFFFF;
      border-radius: 10px;
      padding:18px 20px;
      display: flex;
      &-img{
        width:64px;
        height:64px;
      }
      &-content{
        margin-left:20px;
        display: flex;
        flex-direction: column;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 33px;
      }
    }
  }
  .btn{
    width: 440px;
    height: 80px;
    margin:50px auto 0;
    background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
    border-radius: 40px;
  }
  .next{
    margin-top:30px;
    text-align:center;
    font-size: 32px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FF4633;
    line-height: 45px;
  }
}
.one{
  background: transparent !important;
  td:nth-child(1){
    background: #FFFBF2;
    color:#8C4A00;
  }
  .mt10{
    margin-top:10px;
  }
}
.black{
    background: #eee;
    font-family: PingFangSC-Medium, PingFang SC;
    color: #333333;
    height: 70px;
    display:flex;
    // align-items: center;
    flex-wrap: nowrap;
  }
  .yellow{
    background: #FDF1D6 !important;
    color: #8C4A00 !important;
    height: 70px !important;
    display:flex;
    // align-items: center;
    flex-wrap: nowrap;
  }
.one{
    width: 560px;
    margin:10px auto 0;
    background: #FFFFFF;
    border-radius:20px;
    overflow: scroll;
    max-height:400px;
    tr{
      display: flex;
      background:white;
    }
    td,th{
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 50px;
      overflow: hidden;
      padding:10px 10px 10px 20px;
      // text-overflow: ellipsis;
      //  white-space: nowrap;
    }
    &-item{
      font-size: 26px;
      display:flex;
      justify-content:space-between;
      align-items:center;
    }
  }
</style>